import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi.js";
import HeroSection from "./about_hero.jsx";
import { useLang } from "../context/LangContext.js";
import aboutImage from "../assets/about.png";
import "../styles/about.css";

export default function About() {
  const [content, setContent] = useState({});
  const { lang } = useLang();
  useEffect(() => {
    fetchPageContent("about", lang).then(data => setContent(data));
  }, [lang]);

  const principles = [
    content.about_principles,
    content.about_principles_1,
    content.about_principles_2,
    content.about_principles_3,
    content.about_principles_4,
    content.about_principles_5,
    content.about_principles_6,
    content.about_principles_7,
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;

  return (
   <section className="about-page">
     <div className="main-hero-section"><HeroSection/></div>
  

      <div className="about-intro">
        {content.about_intro && ( 
        <p>{content.about_intro}</p>
        )}
         {content.about_text_1 && ( 
        <p>{content.about_text_1}</p>
        )}
        {content.about_text_2 && ( 
        <p>{content.about_text_2}</p>
        )}
        {content.about_text_3 && ( 
        <p>{content.about_text_3}</p>
        )}
        {content.about_text_4 && ( 
        <p>{content.about_text_4}</p>
        )}
        {content.about_text_5 && ( 
        <p>{content.about_text_5}</p>
        )}
      </div>
        
    

      {/* principles List */}
     <div className="about-principles-section">
      <h2 className="about-principles-title">
        {content.about_title_1}
        </h2>
       <div className="about-principles">
        {principles.map((service, idx) => (
          <div key={idx} className="about-service-item">
            ✔ {service}
          </div>
        ))}
      </div>
      </div>

<div className="gold-divider"></div>

<div className="about-story-section">

  <div className="about-story-image">
    <img
      src={aboutImage}
      alt="Ship hull construction"
    />
  </div>

  <div className="about-story-content">
    <p>{content.about_text_7}</p>
    <p>{content.about_text_8}</p>
    <p>{content.about_text_9}</p>
    <p>{content.about_text_10}</p>
  </div>

</div>

      <div className="spacer"/>
    
    </section>
    

  );

};